import axios from "axios";
const client = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_API_URL || "https://api.talktokam.com",
});
export default client;
